import React from "react";
import "./vikas.css";

const VikasKame = () => {
  const works = [
    {
      title: "जिल्हा वार्षिक निधी सन 24/25 अंतर्गत स्मशान भूमी पोहोच रस्ता बांधकाम",
      desc: "स्मशान भूमीपर्यंतचा रस्ता बांधकाम पूर्णत्वास आले. ग्रामस्थांना सोयीचे झाले.",
      year: "--",
      image: "/images/ghat.jpeg",
    },
    {
      title: "मुख्यमंत्री समृद्ध पंचायत राज अभियान अंतर्गत ग्राम पंचायत इमारतीवर रेन वॉटर हार्वेस्टिंग",
      desc: "ग्रामपंचायत इमारतीवर रेन वॉटर हार्वेस्टिंग सिस्टीम बसवण्याचे काम पूर्ण झाले. पाणी जतनासाठी उपयुक्त.",
      year: "--",
      image: "/images/rainwater.jpeg",
    },
    {
      title: "जिल्हा वार्षिक निधी सन 23/24 रस्ता डांबरीकरण काम",
      desc: "गावातील मुख्य रस्त्याचे डांबरीकरण पूर्ण. प्रवास सोपा व सुरक्षित झाला.",
      year: "--",
      image: "/images/damber.jpeg",
    },
    {
      title: " काम व कपडे वाटप",
      desc: "गावातील रस्ता विकास काम सुरू असून गरजू कुटुंबांना कपडे वाटप कार्यक्रम आयोजित केला.",
      year: "--",
      image: "/images/kapde.jpeg",
    },
    {
      title: "जिल्हा वार्षिक निधी सन 23/24 रस्ता डांबरीकरण काम",
      desc: "गावातील मुख्य रस्त्याचे पूर्ण. प्रवास सोपा व सुरक्षित झाला.",
      year: "--",
      image: "/images/roller.jpeg",
    },

    {
      title: "दिव्यांग लाभार्थी यांना धनादेश वाटप",
      desc: "गावातील  विकास काम सुरू असून गरजू दिव्यांग लाभार्थी यांना धनादेश वाटप कार्यक्रम आयोजित केला.",
      year: "--",
      image: "/images/handicap.jpeg",
    },
    {
      title: "सर्व लाभार्थी यांना प्रशस्तीपत्र वाटप",
      desc: "मुख्यमंत्री समृध्द पंचायत राज अभियान अंतर्गत विहित कालमर्यादेत घरकुल बांधकाम पूर्ण केल्याने सर्व लाभार्थी यांना प्रशस्तीपत्र देऊन मा.सरपंच महोदय यांचे वतीने गौरविण्यात आले.",
      year: "--",
      image: "/images/patra.jpeg", 
    },
    {
      title: "गरोदर माता आरोग्य तपासणी शिबिर",
      desc: "अभियान कालावधीत अंगणवाडी मध्ये गरोदर माता आरोग्य तपासणी शिबिर आणि लहान मुलामुली चे नियमित लसीकरण.",
      year: "--",
      image: "/images/mata.jpeg", 
    },
    {
      title: "स्वच्छ हात धुवा दिवस ",
      desc: "जिल्हा परिषद शाळा इथलापूर येथे स्वच्छ हात धुवा दिवस  मा.सरपंच महोदय यांचे प्रमुख उपस्थित साजरा  करण्यात आला",
      year: "--",
      image: "/images/clean.jpeg", 
    },
    // बाकीचे कामे (फोटो नसलेले) जसेच ठेवले
    {
      title: "🏛️ ग्रामपंचायत मालमत्ता व सुविधा",
      desc:
        "१) ग्रामपंचायत कार्यालय\n" +
        "२) ग्रामपंचायत सभागृह\n" +
        "३) सार्वजनिक स्वच्छतागृह (पुरुष / महिला)\n" +
        "४) घनकचरा व्यवस्थापन सुविधा\n" +
        "५) दुकान गाळे (भाडे तत्त्वावर)\n" +
        "६) पाणीपुरवठा टाक्या व नळजोडणी\n" +
        "७) इतर ग्रामपंचायत उपक्रम व साधने",
      year: "नियमित सेवा",
    },
    {
      title: "✅ पाणीपुरवठा योजना सुधारणा",
      desc: "गावातील पाण्याची समस्या सोडवण्यासाठी नवीन नळ लाईन आणि टाकी दुरुस्तीचे काम पूर्ण.",
      year: "2024-25",
    },
    // ... तुझ्या बाकी सगळ्या कामांचा डेटा इथे जसाचा तसा ठेव (शिक्षण, घरकुल, योजना इ.)
    // मी फक्त मुख्य भाग दाखवतो, तू तुझ्या कोडमधून बाकी पेस्ट कर.
  ];

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">🏗 विकास कामे (Development Works)</h2>
      <div className="vikas-grid">
        {works.map((work, index) => (
          <div className="vikas-card" key={index}>
            {/* फोटो असल्यास दाखव – हे महत्वाचं आहे! */}
            {work.image ? (
              <div className="work-image-wrapper">
                <img
                  src={work.image}
                  alt={work.title}
                  className="work-image"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/400x250/cccccc/666666?text=फोटो+उपलब्ध+नाही";
                    e.target.alt = "फोटो लोड झाला नाही";
                  }}
                />
              </div>
            ) : null}

            <h3 className="work-title">{work.title}</h3>
            <p className="work-desc" style={{ whiteSpace: "pre-line" }}>
              {work.desc}
            </p>
            {work.year && <p className="work-year">📅 वर्ष : {work.year}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VikasKame;